import { FC, PropsWithChildren } from 'react';
import {
  RadioProvider,
  RadioProviderProps,
  useRadioContext,
} from '@/components/functional/RadioInput/RadioContext.tsx';
import CheckboxInput, { CheckboxInputProps } from '@/components/functional/CheckboxInput/CheckboxInput.tsx';

function Group<T>({ children, ...props }: PropsWithChildren<RadioProviderProps<T>>) {
  return <RadioProvider {...props}>{children}</RadioProvider>;
}

const Input: FC<Omit<CheckboxInputProps, 'type'>> = ({ label, wrapperClassName, value, color, ...rest }) => {
  const { value: globalValue, setValue, error, color: globalColor } = useRadioContext();

  return (
    <CheckboxInput
      wrapperClassName={wrapperClassName}
      error={error}
      label={label}
      value={value}
      checked={value === globalValue}
      onChange={(e) => setValue(e.target.value)}
      color={color ?? globalColor}
      {...rest}
      type="radio"
    />
  );
};

export default {
  Group,
  Input,
};
